import {
  overrideNetworkRpcUrl,
  DynamicContextProvider,
} from "@dynamic-labs/sdk-react-core";
import { ToastContainer } from "react-toastify";
import { EthereumWalletConnectors } from "@dynamic-labs/ethereum";

import RoutesManager from "./routes";
import { Env } from "./common/constants/env";
import Loader from "./components/loader/loader";
import PWAInstallHandler from "./components/PWAInstallHandler";

const evmRpcUrlOverrides = {
  1: [Env.MAINNET_RPC_URL],
  80002: [Env.AMOY_RPC_URL],
};

const App = () => {
  return (
    <>
      <DynamicContextProvider
        settings={{
          shadowDOMEnabled: false,
          environmentId: Env.ENVIRONMENT_ID,
          walletConnectors: [EthereumWalletConnectors],
          overrides: {
            evmNetworks: (networks) =>
              overrideNetworkRpcUrl(networks, evmRpcUrlOverrides),
          },
        }}
      >
        <Loader />
        <PWAInstallHandler />
        <RoutesManager />
        <ToastContainer
          newestOnTop
          autoClose={3000}
          hideProgressBar
          closeButton={false}
        />
      </DynamicContextProvider>
    </>
  );
};

export default App;
